import { StyleSheet, View } from 'react-native';

import { colors, radii, strokes, tint } from '../tokens';
import { Text } from './Text';

export interface BadgeProps {
  label: string;
  /**
   * teal = "FROM DEVICE" (P03), "GIANT PANDA" (P24) · sun = "NEW" (1a/P10, with a 1.5 ink border) ·
   * sunQuiet = "INVITED" (P24f: the sun WELL rather than the sun, and no border — board `#FFF4D6`, ink label)
   * · ink = org tag "BGC" · magenta = reward moments only.
   *
   * **`sun` AND `sunQuiet` ARE NOT INTERCHANGEABLE, and the difference carries meaning.** Solid sun with an
   * ink ring is the app's "look at this" badge; the well is the board's colour for a state that is merely
   * true — *"INVITED is sun, not red: nothing is wrong."*
   */
  tone?: 'teal' | 'sun' | 'sunQuiet' | 'ink' | 'magenta';
}

/** Small uppercase label chip, radius 6. Magenta is reserved for badges and reward moments (CLAUDE.md). */
export function Badge({ label, tone = 'teal' }: BadgeProps) {
  const palette = {
    teal: { bg: colors.paleTeal, fg: colors.deepTeal, border: undefined },
    sun: { bg: colors.sun, fg: colors.ink, border: colors.ink },
    sunQuiet: { bg: tint.sun, fg: colors.ink, border: undefined },
    ink: { bg: colors.ink, fg: colors.white, border: undefined },
    magenta: { bg: colors.magenta, fg: colors.white, border: undefined },
  }[tone];
  return (
    <View
      style={[
        styles.badge,
        { backgroundColor: palette.bg },
        palette.border ? { borderWidth: strokes.quiet, borderColor: palette.border } : null,
      ]}
    >
      <Text variant="badge" style={{ color: palette.fg }}>
        {label}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: radii.badge,
    alignSelf: 'flex-start',
  },
});
